import React from 'react'
import QuizEndGame from './QuizEndGame'

const QuizCitiesEndGame = () => {
  const shareTextTemplate = `Quiz des villes #Mappy\n[SCORE] points en [LEVEL] ! 🎉\n[STARS]`
  return <QuizEndGame shareTextTemplate={shareTextTemplate} />
}

export default QuizCitiesEndGame
